<template>
  <div
    :class="[
      'sidebar',
      {
        'sidebar_closed': !computedModelValue,
        'sidebar_open': computedModelValue
      }
    ]"
  >
    <router-link
      class="sidebar__logo"
      :to="{
            name: firstPageRoute
          }"
    >
      <img
        src="@/assets/img/svg/full-logo.svg"
        alt="MainTest"
        class="sidebar__logo__full"
      />
      <img
        src="@/assets/img/svg/maintest_logo.svg"
        alt="MainTest"
        class="sidebar__logo__mini"
      />
    </router-link>
    
    <div class="sidebar__wrapper">
      <div class="sidebar__inner">
        <div class="sidebar__list">
          <slot name="prepend" />
          <template
            v-for="(item, itemIndex) in computedMenuLinks"
            :key="itemIndex"
          >
            <div
              v-if="item.accessRoles.includes(authUser?.role?.slug)"
              class="sidebar__list__item"
            >
              <button
                :class="['sidebar__list__item__header', {
                    'sidebar__list__item__header--active': item.isChildrenOpen || isRouteMatched(item) // || plan_view
                  }]"
                @click="toggleMenu(item.id, item.route)"
              >
                <div class="sidebar__list__item__title">
                  <svg
                    :data-src="item.icon"
                    class="sidebar__list__item__title__icon"
                  />
                  {{ item.title }}
                </div>
                
                <chevron-bottom-icon
                  v-if="item.children"
                  :class="[
                      'sidebar__list__item__arrow-btn',
                      {
                        'sidebar__list__item__arrow-btn--active': item.isChildrenOpen
                      }
                    ]"
                />
              
              </button>
              
              <div
                v-if="item.children"
                class="sidebar__list__child"
              >
                <mt-slide-in-out-animation v-model="item.isChildrenOpen">
                  <template v-for="(child, childIndex) in item.children">
                    <router-link
                      v-if="child.accessRoles.includes(authUser?.role?.slug)"
                      :key="childIndex"
                      :to="child.route"
                      :class="['sidebar__list__child__item', {
                          'sidebar__list__child__item--active': isRouteMatched2(child.route.name)
                        }]"
                      @click="toggleChildrenMenu(item.id, child.route)"
                    >
                      {{ child.title }}
                    </router-link>
                  </template>
                </mt-slide-in-out-animation>
              </div>
            </div>
          </template>
          <slot name="append" />
        </div>
      </div>
      <button
        class="sidebar__open-close"
        @click="openClose()"
      >
        <SidebarToggleIcon class="sidebar__open-close__icon" />
        
        <span class="sidebar__open-close__text">Свернуть меню</span>
      </button>
    </div>
    
    <div
      class="sidebar__overlay"
      @click="openClose"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import MtSlideInOutAnimation from "@/components/UI/mtSlideInOutAnimation/index.vue";
import ChevronBottomIcon from "@/components/icons/ChevronBottomIcon.vue";
import SidebarToggleIcon from "@/components/icons/SidebarToggleIcon.vue";

export default {
  components: {SidebarToggleIcon, ChevronBottomIcon, MtSlideInOutAnimation},
  props: {
    modelValue: Boolean,
  },
  data() {
    return {
      menuLinks: [
        {
          id: 2,
          title: 'Тесты',
          icon: '/img/icons/sidebar/test_library__logo.svg',
          route: {
            name: 'TestLibrary',
          },
          accessRoles: ['admin', 'metodolog', 'operator'],
          children: [
            {
              title: 'Библиотека',
              route: {
                name: 'TestLibraryTestsIndex',
              },
              accessRoles: ['admin', 'metodolog', 'operator']
            },
            {
              title: 'Собственные',
              route: {
                name: 'TestLibraryTestsPro',
              },
              accessRoles: ['admin', 'metodolog', 'operator']
            },
            {
              title: 'Сеансы',
              route: {
                name: 'TestLibrarySessions',
              },
              accessRoles: ['admin', 'metodolog', 'operator']
            },
            {
              title: 'Результаты',
              route: {
                name: 'TestLibraryResults',
              },
              accessRoles: ['admin', 'metodolog', 'operator']
            },
            /*{
              title: 'Корзина',
              route: {
                name: 'TestLibraryTrash',
              },
              accessRoles: ['admin', 'metodolog', 'operator']
            }*/
          ],
          childrenRoutesName: [
            'TestLibraryTestsIndex',
            'TestLibraryTestsItemSettings',
            'TestLibraryTestsPro',
            'TestLibrarySessions',
            'TestLibraryResults'
          ]
        },
        {
          id: 1,
          title: 'Планы оценок',
          icon: '/img/icons/sidebar/assessment_plans__logo.svg',
          route: {
            name: 'AssessmentPlansList',
          },
          accessRoles: ['admin', 'metodolog', 'operator', 'expert', 'respondent'],
          children: [
            {
              title: 'Список',
              route: {
                name: 'AssessmentPlansList',
              },
              accessRoles: ['admin', 'metodolog', 'operator', 'expert', 'respondent'],
            },
            {
              title: 'Архив',
              route: {
                name: 'AssessmentPlansArchive',
              },
              accessRoles: ['admin', 'metodolog', 'operator', 'expert', 'respondent'],
            }
          ],
          childrenRoutesName: [
            'AssessmentPlansList',
            'AssessmentPlansArchive',
            'AddEdit1',
            'AddEdit2',
            'AddEdit3',
            'AddEdit4',
            'ExpRespCorrespondence',
            'PlanSettings',
            'PlanSettingsNotifications',
            'AssessmentPlanSingleResults',
            'PlanSingleResultsExpertTaskSingle'
          ]
        },
        {
          id: 5,
          title: 'Администрирование',
          icon: '/img/icons/sidebar/administration__logo.svg',
          route: {
            name: 'AdminsList',
          },
          accessRoles: ['admin', 'metodolog', 'operator'],
          children: [
            {
              title: 'Администраторы',
              route: {
                name: 'AdminsList',
              },
              accessRoles: ['admin', 'metodolog', 'operator']
            },
            {
              title: 'Пользователи',
              route: {
                name: 'UsersList',
              },
              accessRoles: ['admin', 'metodolog', 'operator']
            },
            {
              title: 'Биллинг',
              route: {
                name: 'Billing',
              },
              accessRoles: ['admin', 'metodolog', 'operator']
            },
            {
              title: 'События',
              route: {
                name: 'Events',
              },
              accessRoles: ['admin', 'metodolog', 'operator']
            },
            /* {
               title: 'Филиалы',
               route: {
                 name: 'BranchesList',
               },
               accessRoles: ['admin', 'metodolog', 'operator']
             },*/
            {
              title: 'Журнал импорта пользователей',
              route: {
                name: 'LogImport',
              },
              accessRoles: ['admin', 'metodolog', 'operator']
            },
            {
              title: 'Настройки',
              route: {
                name: 'Settings',
              },
              accessRoles: ['admin', 'metodolog', 'operator']
            },
          ],
          childrenRoutesName: [
            'AdminsList',
            'Admin',
            'CreateAdmin',
            'UsersList',
            'UserPlansResults',
            'RespondentCabinetTaskSingle',
            'UserSingle',
            'Billing',
            'Events',
            'LogImport',
            'Settings',
          ]
        }
      ],
      openedNavID: null,
      firstPageId: 1, // стартовая страница
      firstPageRoute: 'AssessmentPlansList', // route стартовой страницы
      openedNavName: null
    };
  },
  computed: {
    ...mapGetters(['authUser']),
    
    computedModelValue: {
      get() {
        return this.modelValue
      },
      set(newValue) {
        this.$emit('update:modelValue', newValue)
      }
    },
    
    computedMenuLinks() {
      return this.menuLinks.map(item => {
        item.isChildrenOpen = this.computedModelValue && (+item.id === +this.openedNavID);
        
        return item;
      })
    }
  },
  
  methods: {
    toggleMenu(id, route) {
      const matched = this.isRouteMatched({route});
      if (!matched) this.$router.push(route);
      
      if(!this.computedModelValue) return;
      
      const foundItem = this.computedMenuLinks.find(item => item.id === id);
      
      if (!foundItem.children) {
        return this.computedMenuLinks.forEach(item => {
          item.isChildrenOpen = false;
        })
      }
      
      this.computedMenuLinks.forEach(item => {
        if (item.id === foundItem.id && this.computedModelValue) {
          return item.isChildrenOpen = !item.isChildrenOpen;
        }
        
        item.isChildrenOpen = false;
      })
      
      this.openedNavID = foundItem.id;
      this.openedNavName = foundItem.route.name;
    },
    
    toggleChildrenMenu(id, route) {
      const foundItem = this.computedMenuLinks.find(item => item.id === id);
      
      this.openedNavID = foundItem.id;
      this.openedNavName = route.name;
      
      if (window.innerWidth < 767) {
        this.computedModelValue = false;
      }
    },
    
    isRouteMatched(item) {
      return item.childrenRoutesName?.includes(this.$route.name) || item.route.name === this.$route.name;
    },
    
    isRouteMatched2(routeName) {
      if (!this.$route.matched[1]?.children.length) return this.$route.matched[1]?.name === routeName;
      
      const foundItem = this.$route.matched[1].children.find(i => i.name === routeName);
      
      return !!foundItem;
    },
    
    openClose() {
      this.computedModelValue = !this.computedModelValue;
      
      if (!this.computedModelValue) {
        this.computedMenuLinks.forEach(item => item.isChildrenOpen = false);
      }
    },
  },
  mounted() {
    const sidebarOpenCache = localStorage.getItem('isSidebarOpen');
    const authUserUuid = localStorage.getItem('authUserUuid');
    this.computedModelValue = sidebarOpenCache ? !!Number(sidebarOpenCache) : true;
    if ((localStorage.getItem('openedNavID')) && (authUserUuid === this.authUser.uuid)) {
      this.openedNavID = localStorage.getItem('openedNavID');
      this.openedNavName = localStorage.getItem('openedNavName');
    } else {
      this.openedNavID = this.firstPageId;
      this.openedNavName = this.firstPageRoute;
    }
    
    if (!this.authUser.isMaintestProConnected) {
      const item = this.menuLinks.find((x) => x.title == 'Тесты')?.children.find((x) => x.title == 'Собственные');
      if (item) item.accessRoles = [];
    }
  },
  watch: {
    openedNavID() {
      localStorage.setItem('openedNavID', this.openedNavID);
      localStorage.setItem('authUserUuid', this.authUser.uuid);
      
    },
    openedNavName() {
      localStorage.setItem('openedNavName', this.openedNavName)
    },
    
    computedModelValue() {
      localStorage.setItem('isSidebarOpen', this.computedModelValue ? '1' : '0');
    },
    
    '$route': function () {
      let findItem = false;
      
      this.menuLinks.map(item => {
        if (item.childrenRoutesName?.includes(this.$route.name)) {
          item.isChildrenOpen = true;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.sidebar {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 94px;
  transition: all 0.5s ease;
  z-index: 99999;
  padding-top: 50px;
  border-right: 1px solid #e5e5e5;
  background-color: #fafafa;
  overflow: hidden;
  
  &__list {
    &__item {
      &__header {
        overflow: hidden;
        width: 63px;
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0 10px 0 17px;
        border-radius: 5px;
        transition: box-shadow .3s, padding .3s, width .3s;
        cursor: pointer;
        
        &--active {
          background-color: rgba(0, 120, 140, 0.1);
          color: $green;
          
          .sidebar__list__item {
            &__title {
              color: $green;
            }
            
            &__arrow-btn {
              color: $green;
            }
          }
        }
      }
      
      &__title {
        display: flex;
        align-items: center;
        color: #c7c7c7;
        white-space: nowrap;
        margin-right: 5px;
        transition: color .3s;
        
        &__icon {
          min-width: 30px;
          max-width: 30px;
          height: 30px;
          margin-right: 20px;
          transition: margin-right .3s;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        &:hover {
          color: $green;
        }
      }
      
      &__arrow-btn {
        width: 20px;
        height: 20px;
        margin-left: auto;
        transition: transform .3s;
        transform: rotate(0deg);
        
        &--active {
          transform: rotate(180deg);
        }
      }
      
      & + & {
        margin-top: 10px;
      }
    }
    
    &__child {
      padding-left: 55px;
      
      &__item {
        display: flex;
        width: 100%;
        padding: 5px 0;
        color: #c7c7c7;
        transition: color .3s;
        
        &:hover {
          color: $green;
        }
        
        &--active {
          color: $green;
        }
      }
    }
  }
  
  &__wrapper {
    max-width: 275px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: 50px 15px;
    height: 100vh;
    
    .sidebar__inner {
      .sidebar__logo {
        display: block;
        margin-bottom: 50px;
        //img {
        //height: 50px;
        //}
      }
      
      .sidebar__list {
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: #c7c7c7;
        
      }
    }
  }
  
  &__open-close {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    
    &__icon {
      color: #C7C7C7;
      flex-shrink: 0;
      margin-right: 10px;
      transition: color .3s, margin .3s;
    }
    
    &__text {
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
      color: #00788c;
      white-space: nowrap;
      max-width: 100%;
      overflow: hidden;
      transition: max-width .3s;
    }
    
    &:hover &__icon {
      color: $green;
    }
  }
  
  &__logo {
    position: relative;
    object-fit: contain;
    margin: 0 15px;
    
    &__full {
      min-width: 220px;
      max-width: 220px;
      opacity: 0;
      transition: opacity .3s;
    }
    
    &__mini {
      width: 52px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      transition: all .3s .3s;
    }
  }
  
  &_open {
    width: 275px;
    border-right: 0;
    box-shadow: 2px 0 18px rgba(0, 0, 0, 0.08);
    
    @include max-sm {
      width: 275px;
    }

    .sidebar {
      &__list {
        &__item {
          &__header {
            width: 100%;
            padding-left: 10px;
          }
          
          &__title {
            &__icon {
              margin-right: 5px;
            }
          }
        }
      }
      
      &__overlay {
        @include max-md {
          opacity: 1;
          visibility: visible;
          pointer-events: auto;
        }
      }
      
      &__logo {
        &__full {
          opacity: 1;
        }
        
        &__mini {
          left: 0;
          transform: unset;
          transition: all 0s;
        }
      }
    }
    
    .title {
      opacity: 1 !important;
    }
  }
  
  &_closed {
    .sidebar {
      &__list {
        &__item {
          position: relative;
          
          &:hover .sidebar__list__child > div {
            max-height: unset!important;
            display: block !important;
            background-color: #fafafa;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            border-radius: 0 10px 10px 0;
            padding: 10px 15px;
          }
        }
        
        &__child {
          position: absolute;
          left: 100%;
          top: 0;
          padding-left: 16px;
          
          > div {
            display: none;
          }
        }
      }
      
      &__open-close {
        &__icon {
          margin-left: 18px;
        }
        
        &__text {
          max-width: 0;
        }
      }
    }
    
    @include max-sm {
      width: 0;
      border-right: 0;
      overflow: hidden;
    }
  }
  
  .title {
    white-space: nowrap;
    opacity: 0;
    transition: all 0.5s ease;
  }
  
  &__overlay {
    position: fixed;
    left: 275px;
    top: 0;
    right: 0;
    opacity: 0;
    visibility: hidden;
    height: 100vh;
    background-color: rgba(0, 0, 0, .5);
    transition: all .3s;
    z-index: -1;
    pointer-events: none;
  }
}

.sub_sidebar {
  padding-left: 60px;
  padding-bottom: 10px;
  
  overflow: hidden;
  transition: max-height 0.5s ease;
  max-height: 0;
  
  .sub_sidebar__li {
    padding-top: 10px;
    
    &:hover {
      color: #00788c;
      cursor: pointer;
    }
  }
}
</style>